// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface AgentRun
 */
export interface AgentRun {
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  id: number;
  /**
   * Agent ID
   * @type {number}
   * @memberof AgentRun
   */
  agent: number;
  /**
   * Kept readable after the agent is renamed or deleted
   * @type {string}
   * @memberof AgentRun
   */
  agentName?: string;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  project: number;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  testPlan?: number;
  /**
   * Test plan regression (run) ID
   * @type {number}
   * @memberof AgentRun
   */
  testPlanRun?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  triggerType?: AgentRunTriggerTypeEnum;
  /**
   * User whose action started the run, and the only user who may rate it
   * @type {number}
   * @memberof AgentRun
   */
  triggeredBy?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  status: AgentRunStatusEnum;
  /**
   * Which launcher driver and host ran this
   * @type {string}
   * @memberof AgentRun
   */
  host?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  containerId?: string;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  systemPromptVersion?: number;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  promptVersion?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  imageTag?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  opencodeVersion?: string;
  /**
   * Which side of the model rotation ran
   * @type {string}
   * @memberof AgentRun
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  endedAt?: string;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  exitCode?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  artifactsUrl?: string;
  /**
   * 1 to 5, set only by the user in triggered_by
   * @type {number}
   * @memberof AgentRun
   */
  rating?: number;
  /**
   * Reason codes, collected when rating is below 5
   * @type {Array<string>}
   * @memberof AgentRun
   */
  ratingReasons?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  ratingComment?: string;
  /**
   *
   * @type {number}
   * @memberof AgentRun
   */
  ratedBy?: number;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  ratedAt?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof AgentRun
   */
  updatedAt?: string;
}

export function AgentRunFromJSON(json: any): AgentRun {
  return {
    id: json["id"],
    agent: json["agent"],
    agentName: !exists(json, "agent_name") ? undefined : json["agent_name"],
    project: json["project"],
    testPlan: !exists(json, "test_plan") ? undefined : json["test_plan"],
    testPlanRun: !exists(json, "test_plan_run")
      ? undefined
      : json["test_plan_run"],
    triggerType: !exists(json, "trigger_type")
      ? undefined
      : json["trigger_type"],
    triggeredBy: !exists(json, "triggered_by")
      ? undefined
      : json["triggered_by"],
    status: json["status"],
    host: !exists(json, "host") ? undefined : json["host"],
    containerId: !exists(json, "container_id")
      ? undefined
      : json["container_id"],
    systemPromptVersion: !exists(json, "system_prompt_version")
      ? undefined
      : json["system_prompt_version"],
    promptVersion: !exists(json, "prompt_version")
      ? undefined
      : json["prompt_version"],
    imageTag: !exists(json, "image_tag") ? undefined : json["image_tag"],
    opencodeVersion: !exists(json, "opencode_version")
      ? undefined
      : json["opencode_version"],
    model: !exists(json, "model") ? undefined : json["model"],
    startedAt: !exists(json, "started_at") ? undefined : json["started_at"],
    endedAt: !exists(json, "ended_at") ? undefined : json["ended_at"],
    exitCode: !exists(json, "exit_code") ? undefined : json["exit_code"],
    error: !exists(json, "error") ? undefined : json["error"],
    artifactsUrl: !exists(json, "artifacts_url")
      ? undefined
      : json["artifacts_url"],
    rating: !exists(json, "rating") ? undefined : json["rating"],
    ratingReasons: !exists(json, "rating_reasons")
      ? undefined
      : json["rating_reasons"],
    ratingComment: !exists(json, "rating_comment")
      ? undefined
      : json["rating_comment"],
    ratedBy: !exists(json, "rated_by") ? undefined : json["rated_by"],
    ratedAt: !exists(json, "rated_at") ? undefined : json["rated_at"],
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function AgentRunToJSON(value?: AgentRun): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    agent: value.agent,
    agent_name: value.agentName,
    project: value.project,
    test_plan: value.testPlan,
    test_plan_run: value.testPlanRun,
    trigger_type: value.triggerType,
    triggered_by: value.triggeredBy,
    status: value.status,
    host: value.host,
    container_id: value.containerId,
    system_prompt_version: value.systemPromptVersion,
    prompt_version: value.promptVersion,
    image_tag: value.imageTag,
    opencode_version: value.opencodeVersion,
    model: value.model,
    started_at: value.startedAt,
    ended_at: value.endedAt,
    exit_code: value.exitCode,
    error: value.error,
    artifacts_url: value.artifactsUrl,
    rating: value.rating,
    rating_reasons: value.ratingReasons,
    rating_comment: value.ratingComment,
    rated_by: value.ratedBy,
    rated_at: value.ratedAt,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum AgentRunTriggerTypeEnum {
  Assignment = "assignment",
  Reassignment = "reassignment",
  Manual = "manual",
}
/**
 * @export
 * @enum {string}
 */
export enum AgentRunStatusEnum {
  Queued = "queued",
  Starting = "starting",
  Running = "running",
  Completed = "completed",
  Failed = "failed",
  Cancelled = "cancelled",
  TimedOut = "timed_out",
}
